import moment from 'moment'
import tableActions from '@/components/common/listTableActions'
import topBar from '@/components/common/listTopBar'
import { mapGetters } from 'vuex'

export default {
  watch:{
    async activeCompany() {
      this.loading = true 
      await this.getList()
      this.loading = false
    }
  },
  data: () => ({
    loading: true,
    totalRows: 0,
    perPage: 10,
    currentPage: 1,
    sortBy: 'id',
    sortDirection: 'desc',
    selectAll: false
  }),
  components: {
    topBar,
    tableActions
  },
  computed: {
    ...mapGetters({
      activeCompany: 'company/activeCompany'
    }),
    filter () {
      return {
        skip: (this.currentPage - 1) * this.perPage,
        take: this.perPage,
        sort: `${this.sortBy},${this.sortDirection}`,
        trash: 0,
        company_id: this.activeCompany.id,
        ...this.activeFilters
      }
    },
    activeFilters () {
      return this.filters.some(item => item.model)
        ? this.filters
          .filter(item => item.model)
          .map(item => ({ [item.field]: item.model }))
          .reduce((sum, value) => ({ ...sum, ...value }))
        : []
    }
  },
  methods: {
    async getList (currentPage = null) {
      this.currentPage = currentPage ?? this.currentPage

      try {
        const response = await this.api.all(this.filter)
        if (response && response.data) {
          this.items = response.data.list
          this.totalRows = response.data.total
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async removeSelectedItems () {
      this.items
        .filter(item => item.selected)
        .forEach(item => this.removeItem(item))
      this.selectAll = false
    },
    async removeItem (item) {
      try {
        const response = await this.api.delete(item.id)
        if (response && response.data) {
          this.$toasted.success(this.$t('messages.deleted'))
          this.getList()
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async recoverItem (item) {
      try {
        const response = await this.api.restore(item.id)
        if (response && response.data) {
          this.$toasted.success(this.$t('messages.recovered'))
          this.getList()
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    updatePerPage (perPage) {
      this.perPage = perPage
      this.getList(1)
    },
    updateVisibleFields (field) {
      if (field) {
        field.visible = !field.visible
      }

      this.visibleFields = [
        { key: 'checkbox', label: '' },
        ...Object.values(this.fields)
          .filter(item => item.visible)
          .flatMap(item => ({ key: item.field, label: item.name })),
        { key: 'actions', label: '' }
      ]
    },
    updateSortListBy (field) {
      const fieldItem = this.fields.find(f => f.field === field)

      if (fieldItem && fieldItem.sortable) {
        if (field === this.sortBy) {
          this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
        } else {
          this.sortBy = field
        }
        this.getList()
      }
    },
    updateFilters (filters) {
      this.filters = filters
      this.getList(1)
    },
    formatDateField (field) {
      return field
        ? moment(field).format('DD/MM/YYYY HH:mm')
        : '-'
    },
    toggleAllSelectedItems () {
      this.items = this.items.map(item => ({
        ...item,
        ...{ selected: !item.selected }
      }))
    },
    isDeletedAtField (field) {
      return field === 'deleted_at'
    },
    isFileField (field) {
      return field === 'file'
    },
    isDeleted (value) {
      return value && value !== ''
    },
    isDate (type) {
      return type === 'date'
    }
  }
}
